import React from 'react'



import painting1 from '../../assets/painting/after_1.jpg'
import painting2 from '../../assets/painting/after_2.jpg'
import painting3 from '../../assets/painting/painting3.jpg'
import painting4 from '../../assets/painting/painting 4.jpg'






import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination, Navigation,Autoplay } from 'swiper/modules';
function Paintings() {
  return (
    <>
    <div className='wavy-hero-container'>
                    <img src={painting2} className='wavy-hero-img' alt='hero'/>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className='hero-wave'><path fill="var(--dark)" fill-opacity="1" d="M0,288L80,277.3C160,267,320,245,480,245.3C640,245,800,267,960,272C1120,277,1280,267,1360,261.3L1440,256L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className='hero-wave-1'><path fill="#f6f6f6" fill-opacity="1" d="M0,288L80,277.3C160,267,320,245,480,245.3C640,245,800,267,960,272C1120,277,1280,267,1360,261.3L1440,256L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg>
                    <div className='wavy-title'>
                        <p id='services' data-aos="slide-right">SERVICES</p>

                        <p data-aos="slide-left">PAINTING</p>
                    </div>
    </div>








    <div className='service-intro'>
        <div className='service-intro-container'>
            <div className='service-intro-text'>
                <div data-aos="fade-right" className='service-intro-text-wrapper'>
                    <div className='service-intro-text-title'>The <b>MOST</b> Trusted Painting Services in DFW </div>
                    <div className='service-intro-text-sub'>Over 20+ Painting Projects Completed Across DFW</div>
                    <div className='service-intro-text-p' >Give your home a fresh new look with professional painting services from Home Service Experts, where quality workmanship and attention to detail turn your vision into reality. Whether you’re updating a single room or repainting your entire interior or exterior, we work with you to create a finish that fits your style and elevates your space.

                        <br/><br/>From smooth, clean wall finishes and precise trim work to durable exterior coatings and carefully chosen modern colors, every step is completed with care to deliver a long-lasting, flawless result that makes your home feel brand new.</div>
                    <a href='tel:+14697284201'>
                        <button className='service-intro-text-btn'>GET A QUOTE</button>
                    </a>
                </div>
            </div>
            <img src={painting1} data-aos="fade-left" alt='panel'/>
        </div>
    </div>









    <div className='service-cards'>
        <p className='service-cards-title' data-aos="fade">Painting Services <span className='service-cards-accent'>Designed for Your Home</span></p>
        <p className='service-cards-subtitle' data-aos="fade">Discover how our professional painting services can refresh, elevate, and bring new life to every room in your home.</p>
        <div className='service-cards-wrapper'>

            <div className='service-cards-card' data-aos="flip-right">
                <img src={'https://images.unsplash.com/photo-1615874959474-d609969a20ed?auto=format&fit=crop&w=1600&q=70'} alt='card 1'/>


                <div className='service-cards-card-title'>
                    Interior Painting Services: Transforming Homes with Precision and Style

                </div>
                <div className='service-cards-card-subtitle'>
                    A Fresh Look Starts Here
                </div>

                <div className='service-cards-card-p'>
At Home Service Experts, we specialize in transforming homes and apartments with professional interior painting services. Whether you’re refreshing a single room or updating your entire property, our experienced painters deliver high-quality results with precision and attention to detail. From walls and ceilings to trim and cabinetry, we ensure every surface is finished flawlessly to enhance the beauty and value of your space.
                </div>
            </div>



            <div className='service-cards-card' data-aos="flip-right">
                <img src={'https://images.unsplash.com/photo-1562259949-e8e7689d7828?auto=format&fit=crop&w=1600&q=70'} alt='card 2'/>

                <div className='service-cards-card-title'>
                    Color Selection & Finish Customization: Designed Around Your Style
                </div>

                <div className='service-cards-card-subtitle'>
                    Bring Your Vision to Life
                </div>

                <div className='service-cards-card-p'>
We work closely with you to choose the perfect colors and finishes that match your personal style and create the atmosphere you want in your home. Whether you prefer bold modern tones or soft neutral palettes, our team helps guide the selection process to achieve a cohesive and inviting look. Every project is tailored to reflect your taste while maintaining a professional, polished result.                </div>
            </div>




            <div className='service-cards-card' data-aos="flip-right">
                <img src={'https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?auto=format&fit=crop&w=1600&q=70'} alt='card 3'/>
                <div className='service-cards-card-title'>Surface Preparation & Detailed Finishing: Built for Long-Lasting Quality</div>
                <div className='service-cards-card-subtitle'>
                    A Perfect Finish Starts with the Right Foundation
                </div>
                <div className='service-cards-card-p'>
                    Before any paint is applied, our team performs thorough preparation including patching, sanding, and surface repair to ensure a smooth and durable finish. This attention to detail allows us to deliver results that not only look exceptional but also last longer over time. With Home Service Experts, every project is completed with craftsmanship you can see and quality you can trust.                </div>
            </div>




        </div>
    </div>









    <div className='service-cta'>
        <div className='service-cta-container'>
            <div className='service-cta-text'>
                <div>
                    <p className='service-cta-text-title' data-aos="fade">Start Your Painting <b>Redesign Today</b></p>
                    <p className='service-cta-text-subtitle' data-aos="fade">If you’re ready to refresh your home with a professional paint job, contact Home Service Experts today. Our team is happy to discuss your project, answer your questions, and provide a free estimate to help you get started.</p>
                </div>
                <a href='tel:+14697284201'>
                    <button className='service-cta-text-button' data-aos="fade">CALL NOW</button>
                </a>
            </div>
            <img className="service-cta-image" alt='service' src={painting3}/>
        </div>
    </div>













    <div className='service-portfolio'>
        <div className='service-portfolio-header'>
            <div className='service-portfolio-header-title' data-aos="fade"><b>Real</b> Projects. <b>Real</b> Results.</div>
            <div className='service-portfolio-header-subtitle' data-aos="fade">Explore our recent interior and exterior painting projects and see how expert craftsmanship transforms ordinary spaces into fresh, vibrant, and beautifully finished homes. Every project we complete is focused on clean lines, lasting durability, and a flawless finish—bringing color, style, and renewed life to every surface.</div>
        </div>
        <div className='service-portfolio-slides'>
            <Swiper
            breakpoints={{
                1200:{
                    slidesPerView: 3,
                  spaceBetween: 15
                },
                900:{
                    slidesPerView: 2

                },
                550:{
                    slidesPerView: 1,

                    spaceBetween: 15
                }
                ,
                0: {
                //   slidesPerView: 2,

                  spaceBetween: 5
                }
              }}
              freeMode={true}
              navigation={true}
              loop={true}
              autoplay={{
                delay: 5000, // Delay in milliseconds (3 seconds)
                disableOnInteraction: true, // Continue autoplay after user interactions
                pauseOnMouseEnter: true, // Pause autoplay on mouse hover
              }}
              modules={[FreeMode, Pagination, Navigation, Autoplay]}
              style={{padding:"20px"}} data-aos="zoom-in">
                <SwiperSlide>
                    <img src={painting1} alt='Bathroom gallery 1'/>
                </SwiperSlide>
                
                <SwiperSlide>
                    <img src={painting2} alt='Bathroom gallery 2'/>
                </SwiperSlide>

                <SwiperSlide>
                    <img src={painting4} alt='Bathroom gallery 3'/>
                </SwiperSlide>


            </Swiper>
        </div>










    </div>




















    </>
  )
}

export default Paintings